var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reset-password-page" }, [
    _c("div", { staticClass: "reset-password-shell" }, [
      _vm._m(0),
      _c(
        "section",
        { staticClass: "reset-card" },
        [
          _c("h1", { staticClass: "title" }, [_vm._v("Reset Password")]),
          _vm.status.visible
            ? _c("a-alert", {
                staticClass: "status-alert",
                attrs: {
                  type: _vm.status.type,
                  message: _vm.status.message,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "a-form-model",
            {
              ref: "resetForm",
              staticClass: "reset-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                layout: "vertical",
                "hide-required-mark": "",
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "Email Address", prop: "email" } },
                [
                  _c("a-input", {
                    attrs: {
                      size: "large",
                      disabled: "",
                      placeholder:
                        "Your email will be filled from the reset link",
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "New Password", prop: "password" } },
                [
                  _c("a-input-password", {
                    attrs: {
                      size: "large",
                      placeholder: "Enter a new password with 8-20 characters",
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "Confirm New Password",
                    prop: "confirmPassword",
                  },
                },
                [
                  _c("a-input-password", {
                    attrs: {
                      size: "large",
                      placeholder: "Re-enter your new password",
                    },
                    model: {
                      value: _vm.form.confirmPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "confirmPassword", $$v)
                      },
                      expression: "form.confirmPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "Email Verification Code",
                    prop: "emailCode",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "code-row" },
                    [
                      _c("a-input", {
                        attrs: {
                          size: "large",
                          maxlength: "6",
                          placeholder: "Enter the 6-digit code",
                        },
                        model: {
                          value: _vm.form.emailCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "emailCode", $$v)
                          },
                          expression: "form.emailCode",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          staticClass: "code-btn",
                          attrs: {
                            size: "large",
                            disabled: _vm.sendCodeDisabled,
                            loading: _vm.sendingCode,
                          },
                          on: { click: _vm.handleSendCode },
                        },
                        [_vm._v(" " + _vm._s(_vm.codeButtonText) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "submit-btn",
                      attrs: {
                        type: "primary",
                        size: "large",
                        block: "",
                        loading: _vm.submitting,
                        disabled: _vm.submitDisabled,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" Reset Password ")]
                  ),
                  _vm.showBackButton
                    ? _c(
                        "a-button",
                        {
                          staticClass: "back-btn",
                          attrs: { size: "large", block: "" },
                          on: { click: _vm.goToLogin },
                        },
                        [_vm._v(" Back to Login ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "brand" }, [
      _c("img", {
        staticClass: "brand-logo",
        attrs: {
          src: "http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png",
          alt: "NEEWER",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }